import React, {useEffect} from "react";
import UserManagerPage from "./UserManagerPage";
import {
    IonIcon, useIonAlert, useIonModal
} from "@ionic/react";
import {pencilOutline, pencilSharp} from "ionicons/icons";
import UserManagerEditUserDetails from "./UserManagerEditUserDetails";
import {useRouteMatch} from "react-router";
import {useMutation, useQuery} from "@apollo/client";
import UserManagerEditUserRoles from "./UserManagerEditUserRoles";
import UserManagerEditUserRules from "./UserManagerEditUserRules";
import {formatDatetime} from "../../utils";
import ModalUpdatePassword from "./modals/ModalUpdatePassword";
import {OverlayEventDetail} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import {USER_GET_USER_QUERY, USER_MANAGER_UPDATE_USER} from "../../schemas/userManager";

const UserManagerEditUser: React.FC<any> = () => {

    const [presentAlert, dismissAlert] = useIonAlert();
    const [user, setUser] = React.useState<{id:number,name:string,email:string,status:number,details: string,visited:Date,registered:Date,color:string,user_roles:any, user_rules: any, rules_combined: any} | undefined | null>(null);
    const [presentUpdatePassword, dismissUpdatePassword] = useIonModal(ModalUpdatePassword, {dismiss: (data: string, role: string) => dismissUpdatePassword(data, role)});

    const match:any = useRouteMatch();
    const {loading:userLoading, error:userError, data: userData, refetch} = useQuery(USER_GET_USER_QUERY, {variables: {id:Number(match.params.id)}});

    const [updateUserMutation] = useMutation(USER_MANAGER_UPDATE_USER);

    useEffect(() => {
        if (userData) {
            setUser(userData.getUserData);
        }
    }, [userData]);

    const passwordUpdatePrompt = async () => {
        if (!user) {
            return;
        }
        presentUpdatePassword({
            onWillDismiss: async (ev: CustomEvent<OverlayEventDetail>) => {

                if (ev.detail.role === 'confirm') {
                    const popupData = ev.detail.data;
                    if (!popupData || popupData.length < 8) {
                        presentAlert('Please enter a password that is 8 characters or more!');
                    } else {
                        const result = await updateUserMutation({
                            variables: {
                                data: {
                                    id: user.id,
                                    password:popupData
                                }
                            }
                        });
                        if (result.data.userManagerUpdateUser.success) {
                            presentAlert('Successfully updated password');
                        } else {
                            presentAlert('Failed to update password: ' + result.data.userManagerUpdateUser.error);
                        }
                    }
                }

            }
        })
    }

    return (
        <UserManagerPage page={'edit-user'}>
            {user && <div className="userManagerContent">
                <h3>Edit User: {user.name}</h3>
                <div style={{backgroundColor: "white", padding: "10px"}}>
                    <table style={{width: "100%"}}>
                        <tbody>
                        <tr>
                            <td>
                                <table style={{borderSpacing: '10px', borderCollapse: 'separate'}}>
                                    <tbody>
                                    <tr>
                                        <th style={{textAlign: 'left'}}>Name:</th>
                                        <td>{user.name}</td>
                                    </tr>

                                    <tr>
                                        <th style={{textAlign: 'left'}}>Email:</th>
                                        <td>{user.email}</td>
                                    </tr>

                                    <tr>
                                        <th style={{textAlign: 'left'}}>Password:</th>
                                        <td>********&nbsp;&nbsp;&nbsp;&nbsp;
                                            <a onClick={() => passwordUpdatePrompt()} style={{cursor: 'pointer'}}>
                                                <IonIcon md={pencilOutline} ios={pencilSharp} size="small" />
                                            </a>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th style={{textAlign: 'left'}}>Status:</th>
                                        <td>{user.status === 1 && <>Active</>}
                                            {user.status !== 1 && <>Inactive</>}</td>
                                    </tr>

                                    <tr>
                                        <th style={{textAlign: 'left'}}>Details:</th>
                                        <td>{user.details}</td>
                                    </tr>

                                    </tbody>
                                </table>
                            </td>
                            <td style={{textAlign: 'right', verticalAlign: 'top'}}>
                                <table style={{borderSpacing: '10px', borderCollapse: 'separate'}}>
                                    <tbody>
                                    <tr>
                                        <th style={{textAlign: 'left'}}>Registered:</th>
                                        <td>{formatDatetime(user.registered)}</td>
                                    </tr>

                                    <tr>
                                        <th style={{textAlign: 'left'}}>Last Visited:</th>
                                        <td>{formatDatetime(user.visited)}</td>
                                    </tr>


                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </tbody>
                    </table>

                    <h3>User Details</h3>
                    <UserManagerEditUserDetails user={user} setUser={setUser}/>
                    <h3>Roles</h3>
                    <UserManagerEditUserRoles user={user} refetch={refetch} setUser={setUser}/>
                    <h3>Rules</h3>
                    <UserManagerEditUserRules user={user} refetch={refetch} setUser={setUser}/>

                </div>
                </div>
            }

        <div style={{height: '100px'}}></div>
    </UserManagerPage>
    );
}

export default UserManagerEditUser;